module.exports = __webpack_public_path__ + "media/images/icons/country_flags/al-39bea1bbd5380c19a1b85ca68016de10.svg";